module.exports = __webpack_public_path__ + "static/img/04bg@2x.126dc26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/toolbar/04bg@2x.png
// module id = H6wl
// module chunks = 1